var React = require('react');

function Fr (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"11","fill":"white","key":0}),React.createElement("path",{"d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","fill":"#F0F0F0","key":1}),React.createElement("path",{"d":"M22.0003 12C22.0003 7.70038 19.2865 4.03495 15.4785 2.62202V21.3781C19.2865 19.9651 22.0003 16.2997 22.0003 12Z","fill":"#D80027","key":2}),React.createElement("path",{"d":"M2 12C2 16.2997 4.71379 19.9651 8.52176 21.378V2.62202C4.71379 4.03495 2 7.70038 2 12Z","fill":"#0052B4","key":3})]);
}

Fr.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Fr;

Fr.default = Fr;
